import {
  buildProgramAssetMap,
  type ProgramSlug,
} from "./program-images";

export type { ProgramSlug };

/**
 * Legacy asset paths served from web/public/assets/
 */
export const assets = {
  logo: "/assets/aja-B5e6k7Ai.webp",
  hero: "/images/home-hero-charminar.png",
  programsHero: "/images/programs-hero.png",
  team: {
    ceo: "/assets/Phaniraj.png",
    cco: "/assets/Srilatha.png",
    coo: "/assets/Prashanth.png",
    director: "/assets/Dattu.png",
  },
  contactHero: "/images/gallery-01.png",
  eventsHero: "/images/gallery-03.png",
  impactHero: "/images/gallery-04.png",
  contact: [
    "/assets/IMG_5899.JPG",
    "/assets/DSC01055.JPG",
    "/assets/HealthCare-image.png",
  ],
  programs: buildProgramAssetMap(),
  impact: {
    Healthcare: "/assets/healthcare-program.png",
    Education: "/assets/education-program.png",
    "Skill Development": "/images/program-skill-development.webp",
    Goshala: "/images/program-goshala.png",
    "Blood Donation": "/images/program-blood-donation.png",
    "Blanket Distribution": "/assets/DSC01055.JPG",
  },
  donateSunset: "/assets/donate-sunset-children.png",
  adminLoginHero: "/assets/admin-login-children.png",
  fieldWork: [
    "/images/gallery-01.png",
    "/images/gallery-02.png",
    "/images/gallery-03.png",
    "/images/gallery-04.png",
    "/images/program-healthcare.png",
  ],
} as const;

export function getProgramImage(slug: string): string {
  return (
    assets.programs[slug as ProgramSlug] ?? "/assets/HealthCare-image.png"
  );
}
